import { sellingPoints, productInfo } from "@/mocks/product";

export default function ProductOverview() {
  return (
    <section id="product" className="w-full bg-[#faf9f7] py-20 md:py-28">
      <div className="w-full px-6 md:px-12 lg:px-20">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center mb-16 md:mb-20">
            <div>
              <span className="text-xs font-medium text-stone-400 tracking-widest uppercase">
                Item #{productInfo.itemNumber}
              </span>
              <h2
                className="mt-4 text-3xl md:text-5xl font-light text-stone-900 leading-tight"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                A Fine Bottle
                <br />
                A Happy Cat
              </h2>
              <p className="mt-4 text-sm md:text-base text-stone-500 max-w-md leading-relaxed">
                Inspired by the art of fine wine, this sleek bottle-shaped scratcher
                blends into your home decor while giving your cat the perfect place to scratch.
              </p>

              <div className="mt-8 grid grid-cols-3 gap-4 max-w-sm">
                <div className="text-center p-3 bg-white rounded-xl border border-stone-100">
                  <p className="text-lg font-bold text-stone-900">{productInfo.dimensions.height}</p>
                  <p className="text-[10px] text-stone-400 uppercase tracking-wider mt-1">Height</p>
                </div>
                <div className="text-center p-3 bg-white rounded-xl border border-stone-100">
                  <p className="text-lg font-bold text-stone-900">{productInfo.dimensions.width}</p>
                  <p className="text-[10px] text-stone-400 uppercase tracking-wider mt-1">Width</p>
                </div>
                <div className="text-center p-3 bg-white rounded-xl border border-stone-100">
                  <p className="text-lg font-bold text-stone-900">3-Step</p>
                  <p className="text-[10px] text-stone-400 uppercase tracking-wider mt-1">Assembly</p>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="relative aspect-square rounded-2xl overflow-hidden bg-stone-100">
                <img
                  src={productInfo.images.hero}
                  alt={productInfo.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -left-4 md:-bottom-6 md:-left-6 w-28 h-28 md:w-36 md:h-36 rounded-xl overflow-hidden border-4 border-white shadow-lg">
                <img
                  src={productInfo.images.detail1}
                  alt="Natural jute rope detail"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {sellingPoints.map((item, index) => (
              <div
                key={item.id}
                className="group bg-white rounded-2xl overflow-hidden border border-stone-100"
              >
                <div className="relative aspect-square bg-stone-100 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>

                <div className="p-6 md:p-8 text-center">
                  <h3 className="text-base md:text-lg font-semibold text-stone-900">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm text-stone-500 leading-relaxed">
                    {item.description}
                  </p>

                  <div className="mt-5 flex justify-center">
                    <a
                      href="#find-at-costco"
                      className={`px-6 py-2.5 text-sm font-medium rounded-full transition-colors whitespace-nowrap ${
                        index === 0
                          ? "bg-stone-900 text-white hover:bg-stone-800"
                          : "border border-stone-300 text-stone-700 hover:bg-stone-50"
                      }`}
                    >
                      {item.cta}
                    </a>
                  </div>

                  <p className="mt-4 text-xs text-stone-400">
                    Exclusively at Costco
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}